import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  installmentOption: {
    display: 'flex',
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(2),
    gap: theme.spacing(2)
  },
  textField: {
    width: '100%',

    appearance: 'textfield',
    '&::-webkit-inner-spin-button': {
      appearance: 'none',
      margin: 0
    },
    '& input': {
      height: 5,
      fontSize: '.875rem',
      fontWeight: 500,
      '&::placeholder': {
        color: theme.palette.secondary.contrastText
      }
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main
    },

    '& .MuiFormHelperText-root': {
      fontSize: '.66rem'
    },

    [theme.breakpoints.up('md')]: {
      width: 160
    }
  },
  label: {
    fontSize: '.75rem',
    '&.disabled': {
      color: theme.palette.disabled.main
    }
  },
  inputDateField: {
    marginBottom: theme.spacing(0.5),
    '& input': {
      fontSize: '0.85rem',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.9rem'
      }
    },
    '& .MuiFormHelperText-root': {
      fontSize: '.66rem'
    },
    '& > div': {
      paddingRight: 0,
      height: 40,
      width: 160
    },
    '&.timePicker': {
      '&::placeholder': {
        color: 'rgba(105, 105, 105, 1)'
      }
    },

    '& div > button': {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
      },
      width: 40,
      height: 40
    }
  },
  dateContainer: {
    position: 'relative'
  },
  dateField: {
    width: 170,
    '& input': {
      padding: theme.spacing(1.1, 1.8)
    },
    '& fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
      borderStyle: 'solid'
    }
  },
  switchTooltip: {
    width: '100%',
    borderEndStartRadius: 0,
    backgroundColor: theme.palette.primary.main
  },
  switchTooltipArrow: {
    color: theme.palette.primary.main
  },
  errorIcon: {
    color: theme.palette.primary.main,
    width: 22,
    height: 22,
    position: 'absolute',
    right: -20,
    top: 8
  },
  tooltipButton: {
    right: '10px !important'
  },
  saleToContainer: {
    position: 'relative'
  }
}))
